export default __webpack_public_path__ + "static/media/Rubik-SemiBoldItalic.d6ee9cd4.woff";